import { IsEnum, IsOptional } from 'class-validator';

import { DeliveryTypeEnum } from '@onArte/shared/database/enums';

export class CartAuctionUpdateModel {
  @IsOptional()
  @IsEnum(DeliveryTypeEnum)
  public deliveryType?: DeliveryTypeEnum;

  @IsOptional()
  public deliveryAddressId?: string | null;

  @IsOptional()
  public billingAddressId?: string | null;

  @IsOptional()
  public invoiceRequired?: boolean;

  @IsOptional()
  public commentToSeller?: string;
}
